import * as yup from 'yup';

export const paytSchema = yup.object().shape({
  secret_key: yup
    .string()
    .required('Este campo é obrigatório.')
    .min(32, 'Informe uma chave única válida.')
    .max(200, 'Informe uma chave única válida.'),
});
